export class Ga {
  constructor(
    private $window: ng.IWindowService,
    private $location: ng.ILocationService,
  ) {}

  pageview = (virtualEndpoint) => {
    if (typeof this.$window.ga === 'function') {
      this.$window.ga('send', 'pageview', {
        page:
          this.$location.path() +
          (virtualEndpoint ? '/' + virtualEndpoint : ''),
      });
    }
  };

  set = (pName, pValue) => {
    if (typeof this.$window.ga === 'function') {
      this.$window.ga('set', pName, pValue);
    }
  };
}

angular.module('v6CoreModule').service('ga', ($window, $location) => {
  return new Ga($window, $location);
});
